.shipmentItem {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}

.shipmentItem > span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.shipmentItemDetail {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;
}

.shipmentName {
  color: var(--static-text-standard);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.table {
  width: 100%;
  background-color: var(--static-background-standard) !important;
  border-radius: 10px !important;
  border-collapse: collapse;
}

.searchInputContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.searchInput {
  margin-bottom: 0 !important;
}

.bolSpinner::before, .bolSpinner::after {
  border-color: white;
}

.percentageReceivedContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.percentageReceivedText {
  color: var(--sentiment-text-positive);
}

.percentageReceivedLoader {
  background-color: var(--sentiment-text-positive);
  height: 5px;
  border-radius: 6px;
  margin-left: 10px;
}

.externalBadge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0rem 0.375rem;
  border-radius: 6px;
  color: var(--sentiment-text-neutral);
  background: var(--sentiment-background-neutral);
}
